import React, { useEffect, useState } from 'react';

import { IonInput, IonItem, IonLabel } from '@ionic/react';

import Modal, {
  ModalApplyButton,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalTitle,
} from 'components/Modal';
import Typography from 'components/Typography';
import { useAutoFocus } from 'hooks/useAutoFocus';

import { useLoadPresets } from './data';
import { INameForm } from './interfaces';

const NameForm = ({
  onSubmit,
  onClose,
  title,
  initialValue = '',
  screenKey,
}: INameForm) => {
  const [name, setName] = useState<string | undefined | null>(initialValue);
  const [error, setError] = useState<string>('');
  const { data } = useLoadPresets(screenKey);
  const ref = useAutoFocus<HTMLIonInputElement>();
  const validate = (v: string | undefined | null) => {
    if (!v?.trim()) {
      return 'Name is required';
    } else if (
      v !== initialValue &&
      data.some((p: { title: string }) => p.title === v)
    ) {
      return 'Name should be unique';
    }

    return '';
  };

  const handleSubmit = () => {
    const e = validate(name);
    if (e) {
      setError(e);
    } else {
      onSubmit && onSubmit(name);
    }
  };

  useEffect(() => {
    if (error) {
      setError(validate(name));
    }
  }, [error, name]);

  return (
    <Modal onSubmit={handleSubmit} onClose={onClose}>
      <ModalContent>
        <div className={'ion-padding'}>
          <IonItem className={`${error && 'ion-invalid'} `}>
            <IonLabel position={'floating'}>
              <Typography>Name*</Typography>
            </IonLabel>
            <IonInput
              value={name}
              onIonChange={e => setName(e.detail.value)}
              autofocus={true}
              ref={ref}
            />
            {error && <Typography slot={'error'}>{error}</Typography>}
          </IonItem>
        </div>
      </ModalContent>
      <ModalFooter>
        <ModalCloseButton />
        <ModalTitle>{title}</ModalTitle>
        <ModalApplyButton />
      </ModalFooter>
    </Modal>
  );
};

export default NameForm;
